import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { OpenModalContainer } from '../openModalContainer';
import { RefreshButton } from '../refreshButton';
export const NewClientAvailableModal = ({ onClose }) => {
    return (_jsxs(OpenModalContainer, { title: 'New Client Available', onClose: onClose, children: [_jsx(DialogContent, { children: _jsx(DialogContentText, { component: 'div', children: "There's a new version of the Triplejack Poker client. Refresh to get the latest version!" }) }), _jsx(DialogActions, { children: _jsx(RefreshButton, { type: 'labeled' }) })] }));
};
